/**
 * Row of removable chips summarising every active filter, plus "Clear all".
 * chips: [{ key, label, onRemove }] - label reads like "Vendor: SSTech LLC".
 */
export default function FilterChips({ chips, onClearAll, resultCount, totalCount }) {
  if (!chips.length) return null;
  return (
    <div className="filter-chips">
      {resultCount != null && (
        <span className="filter-chips-count">{resultCount} of {totalCount}</span>
      )}
      {chips.map(c => (
        <span key={c.key} className="filter-chip">
          {c.label}
          <button type="button" onClick={c.onRemove} aria-label={`Remove filter ${c.label}`}>×</button>
        </span>
      ))}
      <button type="button" className="btn btn-ghost btn-sm" onClick={onClearAll}>Clear all</button>
    </div>
  );
}
